unit PrepareOperationDisposableItemListType;
{

/* Initial. */

}
interface

uses
  PrepareOperationDisposableItemType;

type
  TPrepareOperationDisposableItemListType = array of TPrepareOperationDisposableItemType;

implementation

end.
